export class UpdateKeyValueRequest {

    public id!: number;
    public descripcion!: string;
    public observaciones!: string;
}
